const routes = [
    {
        path: 'translado',
        name: 'Translado_Solicitacoes',
        component: () => import('./listagem/Listagem.vue'),
    },
    {
        path: 'translado/nova',
        name: 'Translado_Solicitacoes_Nova',
        component: () => import('./formulario/NovaEdicao.vue'),
    },
    {
        path: 'translado/editar/:id',
        name: 'Translado_Solicitacoes_Editar',
        component: () => import('./formulario/NovaEdicao.vue'),
    },
    {
        path: 'translado/:id',
        name: 'Translado_Solicitacoes_Detalhar',
        component: () => import('./detalhamento/Detalhamento.vue'),
    },
];

export default routes;
